import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    name: { label: i18n.t('app.name'), value: '' },
    taxRateMin: { label: i18n.t('app.min'), value: '', type: 'number' },
    taxRateMax: { label: i18n.t('app.max'), value: '', type: 'number' },
  } 
}
const getTranslateColumns = () => [
  { field: 'Name', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
  // { field: 'TaxType', title: i18n.t('app.name'), format: 'TIPOS_CODIGO_IMPUESTO', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '150px', locked: false },
  { field: 'TaxRate', title: i18n.t('invoices.invoices_issuing.tipo'), cell: 'numberTemplate', format: 'percent_decimal', columnMenu: 'myTemplate', locked: false },
  { field: 'idImpuesto', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
]
const getDefaultForm = () => ({
  irpf: '',
  cuotaIRPF: '',
  cuotaSuplido: '',
  // periodoDesde: '',
  // periodoHasta: '',
  irpfMain: false,
  suplidoMain: false,
  periodoMain: false,
})
const getDefaultState = () => {
  return {
    form: getDefaultForm()
  }
}
  
const customState = getDefaultState()
const customGetters = { form: state => state.form }
const customActions = {
  resetForm ({ state }) {
    state.form = getDefaultForm()
  }
}
const mystore = parent({ getTranslateColumns, customState, customGetters, customActions, navigate: false, selectable: true, namespaced: true, getTranslateMasterFilters })

export default mystore
